export const fontWeight = {
  REGULAR: 400,
  MEDIUM: 500,
  SEMIBOLD: 600,
  BOLD: 700,
} as const

export type FontWeights = keyof typeof fontWeight
